import { ScenariosService } from "@/modules/scenarios/services";
import { toast } from "react-toastify";
import { TCriterioData } from "@/modules/users/models";

export const setDefaultScenario = async (
  accountId: number,
  scenarioId: number,
  userId: number
) => {
  try {
    const response = await ScenariosService.setCurrentScenario(
      accountId,
      scenarioId,
      userId
    );

    return response
    
  } catch (error) {
    toast.error("Ocorreu um erro ao alterar o critério.");
   }
};

export const updateScenarioId = (accountId: number, scenarioId: TCriterioData[], newScenarioId: number) => {
  return scenarioId.map((item) =>
    item.accountId === accountId
      ? { ...item, scenarioId: newScenarioId }
      : item
  );
};
